import locale from "~/i18n/translations/en-GB.json";
export default locale;
